import styled from 'styled-components';

export const FooterStyled = styled.div`
  display: flex;
  justify-content: center;
  margin: 6.4rem 0 5rem;
`;
